import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./cems/cems.module').then(m => m.CemsModule) }
];
